import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ItemNavigation } from '../store/chats.reducer';
import { ItemsNavigationComponent } from './items-navigation.component';

@Component({
  selector: 'dmcom-threads-listing-component',
  imports: [TranslateModule, ItemsNavigationComponent],
  animations: [
    trigger('fadeInOut', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('300ms ease-in-out')),
    ]),
  ],
  template: `
    <div class="overflow-y-auto scrollable-component w-full h-full relative">
      <div class="">
        <span
          class="typo-p3 text-p4 text-grayscale-gray-dark pr-8 pl-8 pt-3 pb-3"
        >
          Recents
        </span>
      </div>
      <div
        class="absolute z-10 top-32 flex flex-col w-full py-4"
        [@fadeInOut]="itemNavigations().length > 0 ? 'visible' : 'hidden'"
      >
        <dmcom-items-navigation
          [items]="itemNavigations()"
          (itemClicked)="itemClicked.emit($event)"
        ></dmcom-items-navigation>
      </div>

      <div
        class="absolute top-32  w-full h-[192px] px-24 py-24 flex flex-col items-center justify-center gap-8"
        style="border-radius: 12px; border: 1px dashed var(--Greyscale-gray, #C8C9CC); aspect-ratio: 4/3;"
        [@fadeInOut]="itemNavigations().length === 0 ? 'visible' : 'hidden'"
      >
        <span class="typo-p4 text-grayscale-black">No Requests Yet</span>
        <p class="typo-p4 text-center px-12 text-grayscale-gray-dark">
          Ask something to get started.<br />Your requests will show up here.
        </p>
      </div>
    </div>
  `,
  styles: [],
})
export class ThreadsListingComponent {
  public readonly itemNavigations = input.required<ItemNavigation[]>();

  public readonly itemClicked = output<ItemNavigation>();
}
